import { render, staticRenderFns } from "./CardEditorial.vue?vue&type=template&id=f5ed9f06&"
import script from "./CardEditorial.vue?vue&type=script&lang=js&"
export * from "./CardEditorial.vue?vue&type=script&lang=js&"
import style0 from "./CardEditorial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports